class GraphEntity {
    constructor(value, graph) {
        this._graph = graph;
        this.value = value;
    }
}

export default GraphEntity;